import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import DownloadItemTab from './TabPanels/DownloadItemTab';
import PublicLinkTab from './TabPanels/PublicLinkTab';

const DownloadSingleItemPopup = ({
  item,
  onClose,
}) => {
  const [selectedTab, setSelectedTab] = useState(
    (item.type === 'render' || item.type === 'video') ? 'descargar' : 'public-link',
  );
  const [resolutions] = useState(() => {
    if (item.type === 'render') {
      return [
        {
          type: 'sd',
          src: item.src
            .replace('live', 'download')
            .replace('.jpg', '_sd.jpg')
            .replace('.png', '_sd.png')
            .replace('.mp4', '_sd.mp4'),
          description: 'Calidad BÁSICA - Recomendado para redes sociales',
        },
        {
          type: 'md',
          src: item.src.replace('live', 'download'),
          description: 'Calidad MEDIA - Recomendado para web',
        },
        {
          type: 'hd',
          src: item.src
            .replace('live', 'download')
            .replace('.jpg', '_hd.jpg')
            .replace('.png', '_hd.png')
            .replace('.mp4', '_hd.mp4'),
          description: 'Calidad ALTA - Recomendado para catálogos o pantallas gran formato',
        },
      ];
    }

    return null;
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  return (
    <div className="download-single-item-popup-container">
      <div className="download-popup">
        <div className="header">
          <div className="title">Descargar y publicar contenido</div>
          <button type="button" className="close-button" aria-label="Close" onClick={onClose} />
        </div>
        <div className="content">
          <img className="image" src={item.thumb !== undefined ? item.thumb : item.src} alt="" />
          <div className="navigation">
            {(item.type === 'render' || item.type === 'video') && (
              <button
                type="button"
                className={`descargar${selectedTab === 'descargar' ? ' selected' : ''}`}
                aria-label="Descargar"
                onClick={() => setSelectedTab('descargar')}
              >DESCARGAR
              </button>
            )}
            <button
              type="button"
              className={`public-link${selectedTab === 'public-link' ? ' selected' : ''}`}
              aria-label="Public Link"
              onClick={() => setSelectedTab('public-link')}
            >PUBLIC LINK
            </button>
          </div>
          <div className="divider" />
          {selectedTab === 'descargar' && (item.type === 'video' ? (
            <React.Fragment>
              <div className="title-download">Puedes descargar el video a continuación:</div>
              <div className="form video-download">
                <button
                  type="button"
                  className="submit enabled"
                  onClick={() => window.open(item.src.replace('live', 'download'), '_self')}
                >Descargar
                </button>
              </div>
            </React.Fragment>
          ) : <DownloadItemTab resolutions={resolutions} />)}
          {selectedTab === 'public-link' && <PublicLinkTab publicLink={item.src} />}
        </div>
      </div>
    </div>
  );
};
DownloadSingleItemPopup.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    src: PropTypes.string,
    thumb: PropTypes.string,
    type: PropTypes.string,
    category: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DownloadSingleItemPopup;
